import PropTypes from "prop-types";
import FileField from "components/helpers/form/file-field";

function ImageField({id, onChange, name, value = null}) {
  return (
    <div className="input-group mb-3">
      <div className="input-group-prepend">
        <label className="input-group-text" htmlFor={id}>Image</label>
      </div>
      <FileField id={id} name={name} onChange={onChange} value={value} />
      {value && value.includes("/") && (
        <img alt={name} className="img-fluid mt-2" src={value} />
      )}
    </div>
  );
}

ImageField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

export default ImageField;
